import { Component, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-video-youtube',
  templateUrl: './video-youtube.component.html',
  styleUrls: ['./video-youtube.component.less']
})
export class VideoYoutubeComponent extends SkeletonSizeBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
